// src/config.js
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Read from Vite environment variable, with fallback
export const API_BASE_URL = import.meta.env.VITE_API_URL || (isDevelopment 
  ? 'http://localhost:8000' 
  : 'https://api.connexbi.com'); 

export const config = {
  apiBaseUrl: API_BASE_URL,
  isDevelopment,
};